import {
  DISCOUNT_TYPE,
  RECEIPT_PAYMENT_MODE_ID,
  TCreateReceiptBody,
  TSelectedSkuItem,
} from "@elixir/types";
import Fuse from "fuse.js";
import { TReceiptEntity } from "../types/billing";
import { PatientProfileWithAbha } from "./appointment-utils";
import { massageMobileNumberForReceipt } from "./receipt-utils";

const filterByNameAndPhoneOptions = {
  location: 0,
  threshold: 0.3,
  distance: 100,
  keys: ["patient.fln", "patient.mobile", "uhid"],
};

export const getFilteredReceiptsByNameAndPhone = ({
  receipts,
  nameOrPhoneorUHIDString,
}: {
  receipts: TReceiptEntity[];
  nameOrPhoneorUHIDString: string;
}) => {
  if (!nameOrPhoneorUHIDString) return receipts;
  const fuse = new Fuse(receipts, filterByNameAndPhoneOptions);
  const response = fuse?.search(nameOrPhoneorUHIDString);

  return response?.map(({ item }) => item);
};

/**
 *
 * @deprecated
 *
 */
export const getFilteredByPaymodeAndServiceReceiptEntities = ({
  receipts,
  servicesArray,
  receiptsArray,
}: {
  receipts: TReceiptEntity[];
  servicesArray: number[];
  receiptsArray: string[];
}) => {
  if (!servicesArray.length && !receiptsArray.length) return receipts;
  return receipts.filter((receipt) => {
    let hasSelectedPaymode,
      hasSelectedService = false;
    const { paymentItems, receiptSkus } = receipt;
    for (let i = 0; i < paymentItems.length; i++) {
      const payItem = paymentItems[i];
      if (receiptsArray.includes(payItem.paymode)) {
        hasSelectedPaymode = true;
        break;
      }
    }
    for (let i = 0; i < receiptSkus.length; i++) {
      const skuItem = receiptSkus[i];
      if (servicesArray.includes(skuItem.sku_item.service_id as number)) {
        hasSelectedService = true;
        break;
      }
    }

    return hasSelectedPaymode || hasSelectedService;
  });
};

export const getReceiptObjectForRequest = ({
  clinicId,
  aid,
  selectedSkus,
  selectedPatient,
  selectedPaymode,
}: {
  clinicId: string;
  aid: string;
  selectedSkus: Array<TSelectedSkuItem>;
  selectedPatient: PatientProfileWithAbha;
  selectedPaymode?: RECEIPT_PAYMENT_MODE_ID;
}): TCreateReceiptBody => {
  const totalAmount = selectedSkus.reduce(
    (currAmount, sku) => currAmount + sku.price,
    0
  );

  let fullPhoneNumber = selectedPatient?.mobile || "";

  if (fullPhoneNumber && fullPhoneNumber.startsWith("+")) {
    //use as is
  } else {
    const countryCode =
      selectedPatient?.phone?.code || (selectedPatient as any)?.ccd || "+91";
    if (fullPhoneNumber) {
      fullPhoneNumber = `${countryCode}${fullPhoneNumber}`;
    }
  }

  const finalMobile = massageMobileNumberForReceipt(fullPhoneNumber);

  return {
    meta: {
      clinic_id: clinicId,
      patient_oid: selectedPatient.oid!,
      aid,
    },
    payload: {
      remarks: "",
      amount_due: 0,
      name: `${selectedPatient.fn}`,
      mobile: finalMobile,
      receipt_amount: totalAmount || 0,
      additional_discount_value: 0,
      additional_discount_type: DISCOUNT_TYPE.AMOUNT,
      additional_discount_amount: 0,
      net_amount: totalAmount || 0,
      receipt_payments: [
        {
          amount: totalAmount || 0,
          paymode: selectedPaymode || RECEIPT_PAYMENT_MODE_ID.CASH,
        },
      ],
      receipt_skus: selectedSkus.map((sku) => ({
        service_id: sku?.service_id || null,
        service_name: sku.service_name.toLowerCase(),
        quantity: 1,
        price: sku?.price || 0,
        amount: sku?.price || 0,
        discount_type: DISCOUNT_TYPE.AMOUNT,
        discount_value: 0,
        discount_amount: 0,
        net_amount: sku?.price || 0,
      })),
    },
  };
};
